import styled from "styled-components";

export const MapActionBtn = styled.button`
  position: absolute;
  top: ${({ top }) => top || '60px'};
  right: ${({ theme }) => theme.space[4]};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};
  font-size: 22px;

  &:hover {
    background: ${({ theme }) => theme.colors.gray50};
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &:active {
    background: ${({ theme }) => theme.colors.gray100};
  }
`;

export const MapaDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;

  .map-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .mapboxgl-ctrl,
  .mapboxgl-ctrl-group {
    margin: 57px 12px 0 0;
  }

  #marked,
  #you {
    z-index: 1;
  }

  /* Popup styling */
  .mapboxgl-popup-content {
    border-radius: ${({ theme }) => theme.radius.lg};
    box-shadow: ${({ theme }) => theme.shadows.xl};
    padding: ${({ theme }) => theme.space[4]};
  }

  .mapboxgl-popup-close-button {
    right: 8px;
    top: 8px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.gray400};
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.radius.full};

    &:hover {
      background: ${({ theme }) => theme.colors.gray100};
      color: ${({ theme }) => theme.colors.gray700};
    }
  }

  .mapboxgl-popup-tip {
    border-top-color: ${({ theme }) => theme.colors.white};
  }
`;
